<template>
  <div class="classes-item" @click="onItemClick">
    <img class="classes-cover" :src="item.cover_image" />
    <div class="classes-main">
      <div class="classes-title bold5" :title="item.name">
        <img
          class="tag"
          src="@/assets/images/common/coupon@2x.png"
          v-if="item.is_has_coupon == 1"
        />
        {{ item.name }}
      </div>
      <div
        class="classes-item-course_count"
        v-if="item.course_num != undefined"
      >
        {{ item.course_num }}门课程
      </div>
      <div class="classes-item-course_count" v-else>
        {{ item.courses_count }}门课程
      </div>
      <!-- <div class="classes-subtitle" v-if="item.marketing_language">
        {{ item.marketing_language }}
      </div>
      <div class="classes-subtitle" v-else>&nbsp;</div> -->
      <div class="classes-bottom">
        <div class="classes-teacher">
          <div
            v-if="item.teachers && item.teachers.length > 0"
            class="classes-teacher_avatar-name"
          >
            <template v-if="item.teachers.length == 1">
              <router-link
                class="teacher"
                @click.native.stop
                :to="{
                  name: 'ShowTeachersDetaial',
                  params: { id: item.teachers[0].id },
                  query: { route_name: 'ShowTeachers', route_label: '名师' },
                }"
              >
                <img class="teacher-avatar" :src="item.teachers[0].avatar" />
                <div class="teacher-name">
                  {{ item.teachers[0].real_name }}
                </div>
              </router-link>
            </template>
            <template v-else-if="item.teachers.length == 2">
              <router-link
                class="teacher"
                @click.native.stop
                :to="{
                  name: 'ShowTeachersDetaial',
                  params: { id: item.teachers[0].id },
                  query: { route_name: 'ShowTeachers', route_label: '名师' },
                }"
              >
                <img class="teacher-avatar" :src="item.teachers[0].avatar" />
              </router-link>
              <router-link
                class="teacher1 teacher"
                @click.native.stop
                :to="{
                  name: 'ShowTeachersDetaial',
                  params: { id: item.teachers[1].id },
                  query: { route_name: 'ShowTeachers', route_label: '名师' },
                }"
              >
                <img class="teacher-avatar" :src="item.teachers[1].avatar" />
              </router-link>
              <span class="teacher-name">2位讲师</span>
            </template>
            <template v-else>
              <router-link
                class="teacher"
                @click.native.stop
                :to="{
                  name: 'ShowTeachersDetaial',
                  params: { id: item.teachers[0].id },
                  query: { route_name: 'ShowTeachers', route_label: '名师' },
                }"
              >
                <img class="teacher-avatar" :src="item.teachers[0].avatar" />
              </router-link>
              <router-link
                class="teacher1 teacher"
                @click.native.stop
                :to="{
                  name: 'ShowTeachersDetaial',
                  params: { id: item.teachers[1].id },
                  query: { route_name: 'ShowTeachers', route_label: '名师' },
                }"
              >
                <img class="teacher-avatar" :src="item.teachers[1].avatar" />
              </router-link>
              <div class="teacher1 teacher" @click.stop>
                <img
                  class="teacher-avatar"
                  style="border: none"
                  src="@/assets/images/more.png"
                />
              </div>
              <span
                v-if="item.teachers && item.teachers.length"
                class="teacher-name"
              >
                {{ item.teachers.length }}位讲师
              </span>
            </template>
          </div>
          <div class="classes-sales">{{ item.student_num }}人已报名</div>
        </div>
        <div class="classes-sales-price">
          <div class="signUp" v-if="item.has_buy == 1">已报名</div>
          <CurrencyNew
            v-else
            :price="item.price"
            :priceUnderline="item.underlined_price"
            :priceTwo="true"
            :isUnderlineLeft="isUnderlineLeft"
          ></CurrencyNew>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClassesItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isUnderlineLeft: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onItemClick() {
      this.$router.push({
        name: "ClassesDetail",
        params: { id: this.item.id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-item {
  width: 588px;
  height: 188px;
  margin: 0 24px 24px 0;
  background: white;
  float: left;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  display: flex;
  &:hover {
    box-shadow: 0px 3px 15px 0px #e0e0e0;
  }

  &:nth-child(2n) {
    margin-right: 0;
  }

  /deep/ {
    .price-underline {
      margin-right: 8px;
    }
  }
}

.classes-item-course_count {
  line-height: 22px;
  color: #999999;
  padding: 2px 0px;
  border-radius: 4px;
}

.classes-cover {
  display: block;
  width: 282px;
  height: 188px;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}

.classes-main {
  flex-grow: 1;
  padding: 16px;
  // border: 1px solid #f3f3f3;
  border-top: 0;
}

.classes-title {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  line-height: 22px;
  margin-bottom: 8px;
  // height: 44px;
  //white-space: nowrap;
  //overflow: hidden;
  //text-overflow: ellipsis;
}

.classes-subtitle {
  color: #999999;
  // margin-bottom: 36px;
}

.classes-bottom {
  position: absolute;
  width: 266px;
  display: flex;
  justify-content: space-between;
  bottom: 16px;
  align-items: flex-end;
}

.classes-sales {
  color: #999999;
  line-height: 1;
  font-size: 13px;
}

.classes-item-buy {
  width: 63px;
  height: 63px;
  position: absolute;
  top: 0;
  right: 0;
  background: url("~@/assets/images/classes/buy@2x.png");
  background-size: 100% 100%;
}
.tag {
  height: 16px;
  vertical-align: -3px;
  // margin-right: 5px;
}
.signUp {
  font-size: 16px;
  color: $primary-color;
  font-weight: 600;
}
.teacher {
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.teacher1 {
  margin-left: -10px;
}

.teacher-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: block;
  border: 1px solid #fff;
  box-sizing: border-box;
}

.teacher-name {
  margin-left: 8px;
  height: 32px;
  font-size: 13px;
  color: #333;
  line-height: 32px;
  max-width: 106px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.teacher-num {
  position: absolute;
  height: 23px;
  background: rgba($primary-color, 0.08);
  white-space: nowrap;
  line-height: 23px;
  padding: 0 14px 0 10px;
  font-size: 13px;
  color: $primary-color;
  border-radius: 11px 11px 11px 0;
  top: -11px;
  left: 50%;
  margin-left: 17px;
}
.classes-teacher_avatar-name {
  margin-bottom: 16px;
  display: flex;
}
</style>
